'use client';

import useClarity from '@/lib/clarity/client';
export default function ClarityProvider(t0) {
  const {
    projectId
  } = t0;
  useClarity(projectId);
  return null;
}